import SupportLanguage from './SupportLanguage';

/* #region iso-639 & bcp-47 (used for sch and tch and hkt) language */
export enum StandardLanguageCode {
    ENG = 'en', // English
    SCH = 'zh-CN', // Simplified Chinese
    TCH = 'zh-TW', // Traditional Chinese
    HKT = 'zh-HK', // Hong Kong Traditional Chinese
    JP = 'ja', // Japanese
    KR = 'ko', // Korean
    ID = 'id', // Indonesian
    VI = 'vi', // Vietnamese
    TH = 'th', // Thai
    PT = 'pt', // Portuguese
    ES = 'es', // Spanish
    MS = 'ms', // Malay
    FIL = 'fil', // Filipino
    HI = 'hi', // Hindi
    TR = 'tr', // Turkish
    RU = 'ru', // Russian
    BN = 'bn', // Bengali
    MY = 'my', // Myanmar
    DE = 'de', // German
}

export namespace StandardLanguageCode {
    const standardToSupportLanguageMap: { [language in StandardLanguageCode]: SupportLanguage } = {
        [StandardLanguageCode.ENG]: SupportLanguage.ENG,
        [StandardLanguageCode.SCH]: SupportLanguage.SCH,
        [StandardLanguageCode.TCH]: SupportLanguage.TCH,
        [StandardLanguageCode.HKT]: SupportLanguage.HKT,
        [StandardLanguageCode.JP]: SupportLanguage.JP,
        [StandardLanguageCode.KR]: SupportLanguage.KR,
        [StandardLanguageCode.ID]: SupportLanguage.ID,
        [StandardLanguageCode.VI]: SupportLanguage.VI,
        [StandardLanguageCode.TH]: SupportLanguage.TH,
        [StandardLanguageCode.PT]: SupportLanguage.PT,
        [StandardLanguageCode.ES]: SupportLanguage.ES,
        [StandardLanguageCode.MS]: SupportLanguage.MS,
        [StandardLanguageCode.FIL]: SupportLanguage.FIL,
        [StandardLanguageCode.HI]: SupportLanguage.HI,
        [StandardLanguageCode.TR]: SupportLanguage.TR,
        [StandardLanguageCode.RU]: SupportLanguage.RU,
        [StandardLanguageCode.BN]: SupportLanguage.BN,
        [StandardLanguageCode.MY]: SupportLanguage.MY,
        [StandardLanguageCode.DE]: SupportLanguage.DE,
    };
    const supportToStandardLanguageMap: { [language in SupportLanguage]: StandardLanguageCode } = {
        [SupportLanguage.ENG]: StandardLanguageCode.ENG,
        [SupportLanguage.SCH]: StandardLanguageCode.SCH,
        [SupportLanguage.TCH]: StandardLanguageCode.TCH,
        [SupportLanguage.HKT]: StandardLanguageCode.HKT,
        [SupportLanguage.JP]: StandardLanguageCode.JP,
        [SupportLanguage.KR]: StandardLanguageCode.KR,
        [SupportLanguage.ID]: StandardLanguageCode.ID,
        [SupportLanguage.VI]: StandardLanguageCode.VI,
        [SupportLanguage.TH]: StandardLanguageCode.TH,
        [SupportLanguage.PT]: StandardLanguageCode.PT,
        [SupportLanguage.ES]: StandardLanguageCode.ES,
        [SupportLanguage.MS]: StandardLanguageCode.MS,
        [SupportLanguage.FIL]: StandardLanguageCode.FIL,
        [SupportLanguage.HI]: StandardLanguageCode.HI,
        [SupportLanguage.TR]: StandardLanguageCode.TR,
        [SupportLanguage.RU]: StandardLanguageCode.RU,
        [SupportLanguage.BN]: StandardLanguageCode.BN,
        [SupportLanguage.MY]: StandardLanguageCode.MY,
        [SupportLanguage.DE]: StandardLanguageCode.DE,
    };

    export function from(language: SupportLanguage): StandardLanguageCode {
        return supportToStandardLanguageMap[language];
    }
    export function to(language: StandardLanguageCode): SupportLanguage {
        return standardToSupportLanguageMap[language];
    }

    Object.defineProperty(StandardLanguageCode, 'from', {
        enumerable: false,
    });
    Object.defineProperty(StandardLanguageCode, 'to', {
        enumerable: false,
    });
}
/* #endregion */

/* #region server used language (used for communicate with server) */
export enum ServerUsedLanguage {
    ENG = 'en',
    SCH = 'zh-chs',
    TCH = 'zh-cht',
    HKT = 'zh-hk',
    JP = 'ja',
    KR = 'ko',
    ID = 'id',
    VI = 'vi',
    TH = 'th',
    PT = 'pt',
    ES = 'es',
    MS = 'ms',
    FIL = 'fil',
    HI = 'hi',
    TR = 'tr',
    RU = 'ru',
    BN = 'bn',
    MY = 'my',
    DE = 'de',
}

export namespace ServerUsedLanguage {
    const serverUsedToSupportLanguageMap: { [language in ServerUsedLanguage]: SupportLanguage } = {
        [ServerUsedLanguage.ENG]: SupportLanguage.ENG,
        [ServerUsedLanguage.SCH]: SupportLanguage.SCH,
        [ServerUsedLanguage.TCH]: SupportLanguage.TCH,
        [ServerUsedLanguage.HKT]: SupportLanguage.HKT,
        [ServerUsedLanguage.JP]: SupportLanguage.JP,
        [ServerUsedLanguage.KR]: SupportLanguage.KR,
        [ServerUsedLanguage.ID]: SupportLanguage.ID,
        [ServerUsedLanguage.VI]: SupportLanguage.VI,
        [ServerUsedLanguage.TH]: SupportLanguage.TH,
        [ServerUsedLanguage.PT]: SupportLanguage.PT,
        [ServerUsedLanguage.ES]: SupportLanguage.ES,
        [ServerUsedLanguage.MS]: SupportLanguage.MS,
        [ServerUsedLanguage.FIL]: SupportLanguage.FIL,
        [ServerUsedLanguage.HI]: SupportLanguage.HI,
        [ServerUsedLanguage.TR]: SupportLanguage.TR,
        [ServerUsedLanguage.RU]: SupportLanguage.RU,
        [ServerUsedLanguage.BN]: SupportLanguage.BN,
        [ServerUsedLanguage.MY]: SupportLanguage.MY,
        [ServerUsedLanguage.DE]: SupportLanguage.DE,
    };
    export const supportToServerUsedLanguageMap: { [language in SupportLanguage]: ServerUsedLanguage } = {
        [SupportLanguage.ENG]: ServerUsedLanguage.ENG,
        [SupportLanguage.SCH]: ServerUsedLanguage.SCH,
        [SupportLanguage.TCH]: ServerUsedLanguage.TCH,
        [SupportLanguage.HKT]: ServerUsedLanguage.HKT,
        [SupportLanguage.JP]: ServerUsedLanguage.JP,
        [SupportLanguage.KR]: ServerUsedLanguage.KR,
        [SupportLanguage.ID]: ServerUsedLanguage.ID,
        [SupportLanguage.VI]: ServerUsedLanguage.VI,
        [SupportLanguage.TH]: ServerUsedLanguage.TH,
        [SupportLanguage.PT]: ServerUsedLanguage.PT,
        [SupportLanguage.ES]: ServerUsedLanguage.ES,
        [SupportLanguage.MS]: ServerUsedLanguage.MS,
        [SupportLanguage.FIL]: ServerUsedLanguage.FIL,
        [SupportLanguage.HI]: ServerUsedLanguage.HI,
        [SupportLanguage.TR]: ServerUsedLanguage.TR,
        [SupportLanguage.RU]: ServerUsedLanguage.RU,
        [SupportLanguage.BN]: ServerUsedLanguage.BN,
        [SupportLanguage.MY]: ServerUsedLanguage.MY,
        [SupportLanguage.DE]: ServerUsedLanguage.DE,
    };
    export function from(language: SupportLanguage): ServerUsedLanguage {
        return supportToServerUsedLanguageMap[language];
    }
    export function to(language: ServerUsedLanguage): SupportLanguage {
        return serverUsedToSupportLanguageMap[language];
    }

    Object.defineProperty(ServerUsedLanguage, 'from', {
        enumerable: false,
    });
    Object.defineProperty(ServerUsedLanguage, 'to', {
        enumerable: false,
    });
}
/* #endregion */

// for backward compatibility
export default ServerUsedLanguage.supportToServerUsedLanguageMap;
